wordmark: "banoffee"
tagline: "Intelligent automation for industries left behind by the modern tech stack."

columns:
  - title: "Services"
    links:
      - label: "Workflow Audits"
        href: "#services"
      - label: "Custom AI Builds"
        href: "#services"
      - label: "Orchestration"
        href: "#services"
      - label: "Consultancy"
        href: "#services"
  - title: "Company"
    links:
      - label: "Current Projects"
        href: "#projects"
      - label: "Process"
        href: "#process"
      - label: "FAQ"
        href: "#faq"
      - label: "Privacy Policy"
        href: "/privacy"
      - label: "Terms of Service"
        href: "/terms"
  - title: "Contact"
    links:
      - label: "hello@banoffee.work"
        href: "mailto:hello@banoffee.work"
      - label: "LinkedIn"
        href: "#"
      - label: "X / Twitter"
        href: "#"
      - label: "Book a Call"
        href: "#book"

bottom:
  - "© 2026 Banoffee. All rights reserved."
  - "Built with domain experts. Shipped with precision."
